var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiddleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 48.04,
    height: 46.747,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5853.69 5696.05",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 2823.71,
    y1: 2100.63,
    x2: 3294.1,
    y2: 5275.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 2699.73,
    y1: 4337.3,
    x2: 2874.14,
    y2: 227.96
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#683119"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#7e4020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#944f28"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3437.6,
    y1: 6424.29,
    x2: 2457.95,
    y2: 1556.88
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3810.31,
    y1: 6497.65,
    x2: 2831.03,
    y2: 1366.03
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b",
    x1: 2797.87,
    y1: 6010.73,
    x2: 3111.54,
    y2: -1672.79
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 5161.19,
    y1: 6243.95,
    x2: 4202.5,
    y2: 1109.84
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 4173.3,
    y1: 12530.54,
    x2: 2538.96,
    y2: -2463.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ce9549"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#bc6f3b"
    }
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3260.66,
    y1: 6605.7,
    x2: 2281.02,
    y2: 1472.28
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3096.94,
    y1: 6592.39,
    x2: 2117.25,
    y2: 1596.76
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3698.49,
    y1: 22621.96,
    x2: 3359.36,
    y2: 14250.91
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 3804.87,
    y1: 6500.37,
    x2: 2825.37,
    y2: 1367.6
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a",
    x1: 4007.32,
    y1: 6425.21,
    x2: 3027.96,
    y2: 1321.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 2762.69,
    y1: 6388.32,
    x2: 2740.68,
    y2: 4882.57
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#804125"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopOpacity: 1,
      stopColor: "#9a522d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#b46336"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m2253.8 1881 221.29.37-.18 222.25-222.39-1.29 1.29-221.33zm809.62 1266.33c-116.38 28.83-130.61 181.63-33.8 237.31 46.7 26.85 123.88 17.13 181.77 17.18 45.09.05 163.35 5.16 199.13-4.28 109.93-28.88 128.86-181.68 31.64-237.04-45.82-26.16-123.28-17.32-181.4-17.32-46.79 0-159.44-5.25-197.34 4.14zm554.44-597.68c-57.38 12.11-99.8 57.8-102.93 123.61-2.86 61.2-5.8 412.08 9.53 449.71 51.26 126.09 242.06 98.42 248.69-45.59 2.76-60.47 5.8-413.51-9.12-449.57-19.66-47.39-74.05-93.35-146.17-78.15zm-523.21 176.48c-2.26 95.88-14.64 188.68 37.72 241.69 58.58 59.32 154.14 45.92 194.48-12.94 40.62-59.27 26.07-169.2 26.07-250.02 0-103.76 12.43-171.27-61.94-218.61-47.62-30.3-191.31-18.93-259-18.93-104.68 0-175.74-16.99-233.58 48.86-53.79 61.25-23.72 157.23 34.08 190.8 57.66 33.53 185.23 15.34 262.18 19.16zM1782.82 1410.94c56-4.61 332.18-.97 410.24-.74 175.14.46 183.71-156.72 118.54-219.12-50.7-48.59-86.17-39.51-167.91-39.51h-412.68c-74.51 0-125.68-5.85-169.75 37.76-43.61 43.11-38.13 96.11-38.13 169.71v412.73c0 77.6-8.47 121.95 39.56 168.32 71.66 69.13 219.44 50.24 218.98-119-.18-65.21-3.59-371.42 1.15-410.15zm2202.13 2202.08c-36.7 4.7-346.55 1.38-410.2 1.2-166.57-.55-189.79 143.36-118.91 218.89 45.45 48.4 91.74 39.61 168.28 39.61h412.73c70.51 0 129.96 3.91 169.98-37.9 42.65-44.58 37.49-95.61 37.49-169.94v-412.73c0-76.45 8.15-122.13-39.42-168.09-36.24-34.95-94.78-52.32-151.42-21.74-47.34 25.61-68.02 69.36-67.84 140.46.28 79.17 3.91 352.49-.69 410.24zm-2202.36.32-1.11-410.56c1.8-173.67-155.94-184.07-218.75-118.82-48.77 50.7-39.61 86.9-39.61 168.19v412.73c0 179.98 26.9 207.84 207.88 207.84h412.68c81.93 0 117.44 9.12 168.23-39.61 63.55-61.02 57.66-219.44-118.86-218.94-72.86.23-361.29 3.68-410.47-.83zm2202.08-2202.22c4.51 42.55 1.11 341.53.97 409.97-.14 71.06 21 115.41 67.47 140.78 54.67 29.8 117.67 14.28 151.93-21.92 48.45-51.17 39.28-86.63 39.28-168.19v-412.73c0-73.64 5.48-126.09-37.86-169.66-43.15-43.34-96.16-37.81-169.61-37.81h-412.73c-77.69 0-121.21-8.89-168.05 39.47-70.97 73.22-47.85 221.01 118.68 218.94l409.92 1.15zM2252.65 2921.81l222.11-1.15.37 222.11-221.56.37-.92-221.33zm-146.59-257.9c-130.61 22.84-112.19 135.21-112.05 260.75.09 60.93-3.96 335.73 2.44 371.7 23.07 130.1 167.63 105.42 263.89 105.46 59.32.05 336.23 4.05 371.1-3.04 47.9-9.72 82.99-43.24 96.25-87.46 11.1-37.16 5.94-131.71 5.99-175.83.14-61.3.05-122.59 0-183.89-.05-109.01 27.54-244.54-87.59-282.58-37.76-12.43-299.53-6.86-358.85-6.86-45.73 0-141.94-5.11-181.17 1.75zm1186.38-782.68 221.38-.09 1.01 220.87-222.25 1.61-.14-222.39zm-160.45-254.03c-121.44 33.25-98.19 145.02-98.19 270.15 0 71.89-9.12 314.64 3.87 366.63 11.01 44.12 47.2 81.15 90.63 93.26 29.8 8.34 511.61 8.89 544.67 1.38 118.63-26.85 100.17-143.82 100.3-268.35.09-73.41 9.3-315.33-3.73-369.95-29.61-123.98-169.43-97.73-271.07-97.77-68.67-.05-319.47-8.24-366.49 4.65zm-1037.95-.83c-119.14 28.09-99.98 146.63-99.98 270.98 0 69.22-8.61 320.62 4.65 369.49 33.02 121.49 164.55 95.19 270.61 95.19 72.03 0 314.54 9.12 366.54-3.96 123.56-30.99 97.82-163.81 97.82-267.8 0-57.38 4.14-333.7-3.32-366.95-26.57-118.59-143.41-100.76-268.17-100.76-75.44 0-312.01-9.44-368.15 3.82z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5853.69 2848.62c0 304.69-48.77 597.13-140.37 872.66-165.93 504.7-473.43 947.36-876.03 1283.73-182.14 153.54-383.95 285.62-602.1 390.76-393.39 192.92-837.89 300.27-1307.77 300.27-903.84 0-1712.58-398.59-2248.6-1025.24-248.37-288.98-438.61-626.6-553.47-996.96C44.07 3413.09-.01 3135.29-.01 2848.61c0-102.88 5.8-203.42 16.3-302.66 17.32-156.9 47.53-310.58 89.3-459.57 24.32-86.95 53.33-171.55 87.09-254.03 68.48-177.21 155.38-346.6 259.79-504.7 172.88-268.81 393.34-507 647.51-704.61 71.98-56.42 147.37-110.57 226.21-159.07C1785.62 170.29 2335.72-.02 2927.42-.02c816.89 0 1555.86 326.15 2086.26 852.22 131.11 128.81 249.47 269.87 351.57 421.3 16.26 21.37 30.12 42.83 44.03 65.4 87.04 134.38 161.37 275.58 223.96 423.46 103.21 241.69 171.69 500.14 201.94 770.01 12.62 103.99 18.51 208.9 18.51 316.25z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5387.13 2505.11c0 29.57 0 57.89-2.53 86.21-3.64 136.64-18.28 269.69-44.21 399.01-19.57 97.26-44.3 190.94-73.92 283.32-6.17 20.86-13.4 40.57-20.91 61.57-19.62 57.75-43.01 114.4-66.41 171.13-45.55 104.63-98.32 204.43-156.17 301.74-46.93 75.07-97.31 149.07-151.42 219.21-83.72 108.41-174.77 209.31-274.34 301.6-25.79 26.02-53.05 49.28-80.09 72.67-119.28 104.77-249.7 197.06-388.74 275.91-40.57 24.73-82.48 46.93-125.59 67.7-200.47 101.04-417.06 176.15-643.5 218.06-153.68 30.63-312.47 46.88-474.9 46.88-406.14 0-788.71-97.4-1127.25-268.54-177.03-88.84-340.84-198.31-489.55-325.09-110.8-93.81-212.9-197.06-306.39-307.91-98.51-118.22-185.82-245.19-259.69-379.39-60.15-104.63-111.91-213.04-155.02-326.29-22.15-56.69-41.91-113.24-59.09-171.27-13.45-46.65-27.03-94.73-38.18-142.72-22.06-91.19-39.38-184.67-49.14-280.88-13.63-98.46-19.8-200.7-19.8-302.94 0-89.85 5.02-178.55 14.97-265.96 14.6-137.98 40.43-273.56 76.13-403.98 9.81-36.98 20.95-73.92 33.2-109.61 12.34-39.38 25.79-77.55 40.67-114.49 18.56-49.28 39.38-97.36 61.57-145.34 31.96-73.87 69.95-145.21 110.67-215.48 16.03-28.37 33.2-55.45 50.52-82.48 57.75-92.38 120.52-179.88 189.42-262.37 108.27-131.8 231.33-251.22 364.19-357.05 54.16-44.35 110.71-86.26 171.18-125.77 7.23-4.84 14.6-9.76 22.15-14.6 94.69-62.86 193.01-118.26 296.49-166.48C2136.26 86.46 2500.45.35 2884.4.35c365.39 0 712.4 78.61 1026.25 220.32 103.25 45.55 202.96 99.66 298.89 160.13 167.36 104.63 321.18 229.07 459.01 369.44l2.44 2.44c60.33 60.28 116.84 124.39 171 192.23 44.35 55.31 87.46 114.44 126.83 174.77 13.45 19.71 25.79 38.18 38.13 57.89a2469.777 2469.777 0 0 1 190.75 372.02c20.82 50.34 40.43 102.19 57.66 155.02 32.1 94.82 59.22 192.23 78.84 290.69 15.98 76.31 28.18 153.96 36.93 231.6 2.44 22.15 4.97 43.01 6.17 65.17 7.28 70.28 9.81 141.71 9.81 213.04z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3468.92 425.16c-658.38 2.44-1317.86 1.2-1976.1-2.58 7.23-4.84 14.6-9.76 22.15-14.6 94.69-62.86 193.01-118.26 296.49-166.48 473.66-7.23 948.56-12.07 1422.35-15.98 225.15-2.26 451.64-3.59 676.84-4.84 103.25 45.55 202.96 99.66 298.89 160.13-263.33 14.78-526.62 43.11-740.63 44.35z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4128.4 4677.49c-40.57 24.73-82.48 46.93-125.59 67.7-200.47 101.04-417.06 176.15-643.5 218.06-535.23-57.94-1071.66-184.72-1602.15-221.65-177.03-88.84-340.84-198.31-489.55-325.09 372.66-21.09 751.64 17.18 1139.36 77.46 473.84 74.05 948.7 183.52 1428.57 183.52 42.97 0 161.19 2.58 292.85 0z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3962.19 3796.91c178.41 40.71 601.73 92.43 909.37 230.4-83.72 108.41-174.77 209.31-274.34 301.6-116.88-120.66-393.85-152.62-497.19-178.55-944.92-236.44-1918.35-326.33-2885.42-416.32-102.15-9.81-297.83-1.06-513.08-4.84-60.15-104.63-111.91-213.04-155.02-326.29 196.79 15.98 447.91 2.39 553.74 12.2 958.37 86.26 1921.85 168.74 2861.93 381.78z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4140.6 1029.84c-1138.11 100.99-2286.18 78.8-3423.09 220.41 16.03-28.37 33.2-55.45 50.52-82.48 57.75-92.38 120.52-179.88 189.42-262.37 238.88-8.7 461.45-6.17 617.67-14.92 931.38-51.58 1870.41-14.6 2798.15-102.1 98.37-9.76 198.17-19.71 297.73-35.69 60.33 60.28 116.84 124.39 171 192.23-252.33 51.72-513.03 67.7-701.39 84.92z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4915.86 3534.73c116.88-1.38 203-12.39 263.29-28.37-45.55 104.63-98.32 204.43-156.17 301.74-39.38 2.39-76.36 3.73-107.12 3.73-486.05 4.84-981.99-144.24-1459.29-206.87-345.81-44.49-684.21-92.43-1020.08-186.06-504.56-140.42-1002.81-357.1-1535.6-359.63-56.69 0-276.87-2.44-451.64 29.66-22.06-91.19-39.38-184.67-49.14-280.88 114.3-24.59 221.33-38.13 298.89-44.3 767.89-59.13 1471.68 321.31 2205.03 476.61 392.51 82.48 799.85 113.24 1194.81 179.88 270.66 44.35 541.4 118.08 817.03 114.49z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.05 1729.3c-18.51-1.2-36.93-2.53-55.45-3.73 12.34-39.38 25.79-77.55 40.67-114.49 18.56-49.28 39.38-97.36 61.57-145.34 254.54 36.93 552.36 17.32 793.54 33.3 561.11 38.18 1122.27 72.72 1683.25 103.34 723.54 40.71 1447.09 73.87 2171.73 102.24 32.1 94.82 59.22 192.23 78.84 290.69-910.57-35.6-1820.99-78.84-2731.65-131.8-681.63-39.38-1362.07-84.92-2042.51-134.2z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5213.55 2620.8c-419.55 56.69-851.43 58.03-1278.35 60.47 381.41 284.47 955.97 225.25 1405.18 309.06-19.57 97.26-44.3 190.94-73.92 283.32-6.17 20.86-13.4 40.57-20.91 61.57-65.17-55.4-188.22-107.21-319.89-124.44-543.94-72.63-1086.53-119.55-1426.13-594.82-63.97-91.09 23.53-204.34 119.46-209.31 456.43-19.76 916.69-14.92 1370.78-53.1 134.06-11.01 261.95-31.91 387.54-61.48 7.28 70.28 9.81 141.71 9.81 213.04 0 29.57 0 57.89-2.53 86.21-56.55 12.3-113.29 22.24-171.04 29.47z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1143.82,
    y: 1122.54,
    width: 3255.23,
    height: 3046.46,
    rx: 219.95,
    ry: 241.98,
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1303.26,
    y: 988.88,
    width: 3255.23,
    height: 3046.46,
    rx: 219.95,
    ry: 241.98,
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2424.29 1985.72-21.32-525.61h610.85l-21.32 525.61-85.24 987.34H2509.5l-85.2-987.34zm284.1 1896.47c-101.82 0-186.47-35.51-253.94-106.52-67.47-71.01-101.23-158.65-101.23-262.83 0-104.17 33.76-191.77 101.23-262.78 67.47-71.06 152.11-106.57 253.94-106.57 101.82 0 186.42 35.51 253.94 106.57 67.47 71.01 101.18 158.61 101.18 262.78 0 104.17-33.71 191.81-101.18 262.83-67.51 71.01-152.11 106.52-253.94 106.52z",
    style: {
      fill: "url(#m)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2634.66 1845.95-21.32-525.61h610.85l-21.32 525.61-85.24 987.34h-397.76l-85.2-987.34zm284.1 1896.47c-101.82 0-186.47-35.51-253.94-106.52-67.47-71.01-101.23-158.65-101.23-262.83 0-104.17 33.76-191.77 101.23-262.78 67.47-71.06 152.11-106.57 253.94-106.57 101.82 0 186.42 35.51 253.94 106.57 67.47 71.01 101.18 158.61 101.18 262.78 0 104.17-33.71 191.81-101.18 262.83-67.51 71.01-152.11 106.52-253.94 106.52z",
    style: {
      fill: "#4a2615",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiddleIcon);
export default __webpack_public_path__ + "static/media/riddle_icon.d9be3c1d6873052fdf4b3e6c9c5d70d2.svg";
export { ForwardRef as ReactComponent };